import { render } from "./DynvibeBarChartRace.vue?vue&type=template&id=b0e33420"
import script from "./DynvibeBarChartRace.vue?vue&type=script&lang=js"
export * from "./DynvibeBarChartRace.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__